import { ReactElement } from "react";
import { Alert } from "../../../alert/Alert";

export function SharePricingDialogAlert({
  buyerName,
}: {
  buyerName?: string;
}): ReactElement {
  const message = buyerName
    ? `Anyone you share this link with will have access to the pricing you have set for ${buyerName}.`
    : "Anyone you share this link with will have access to pricing on this price tier";
  return (
    <Alert
      className={"w-full"}
      type={"information"}
      message={message}
      title={"About pricing links"}
    />
  );
}
